import { createContext } from 'react'

import type { Page } from '@subaio/utils'

export type ContextType = {
	readonly page: Page | null
	readonly url: string | null
	getPath: (page: Page, base?: string) => string | null
	push: (page: Page | ((current: Page | null) => Page)) => void
	replace: (page: Page | ((current: Page | null) => Page)) => void
	back: () => void
	subscribe: (handler: () => void) => () => void
	match: (url: string) => Page | null
}

export const context = createContext<ContextType | null>(null)
